import { Proposal, Project, Prestation } from "./state";

/* 
  Return Project 
*/
export const getProject = (state, props): Project | undefined => {
  return state.projects.find(item => item.id === props.projectId);
};

/* 
  Return Prestation 
*/
export const getPrestation = (state, props): Prestation | undefined => {
  const project = getProject(state, props);
  if (!project) {
    return;
  }

  return project.prestations.find(item => item.id === props.prestationId);
};

/* 
  Return Proposal
*/
export const getProposal = (state, props): Proposal | undefined => {
  const prestation = getPrestation(state, props);

  if (!prestation) {
    return;
  }

  const proposal = prestation.proposals.find(
    item => item.uuid === props.proposalUuid
  );

  return proposal;
};



// WEBPACK FOOTER //
// ./src/redux/projects/selectors.ts